var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroPic2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_171",
    "data-name": "Group 171",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45.786,
    height: 65.074,
    viewBox: "0 0 45.786 65.074",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112",
    "data-name": "Rectangle 112",
    width: 45.786,
    height: 65.074,
    fill: "#2c3584",
    stroke: "#2c3584",
    strokeWidth: 2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M2.58,59.914a2.58,2.58,0,1,0,0,5.16H43.209a2.58,2.58,0,0,0,0-5.16H42.7V5.158h.511a2.579,2.579,0,0,0,0-5.158H2.58a2.579,2.579,0,1,0,0,5.158h.656V59.914Zm41.681,2.58a1.054,1.054,0,0,1-1.052,1.054H2.58a1.054,1.054,0,1,1,0-2.108H43.209a1.053,1.053,0,0,1,1.052,1.054M2.58,3.633a1.053,1.053,0,1,1,0-2.107H43.209a1.053,1.053,0,0,1,0,2.107ZM4.761,5.158H41.17V59.914H4.761Z",
    transform: "translate(0 0)",
    fill: "#2c3584",
    stroke: "#2c3584",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M32.759,40.059l-.029-.023-8.968-7.705,9-7.728a11.65,11.65,0,0,0,4.27-8.881,11.656,11.656,0,0,0-4.27-8.882.8.8,0,0,0-.235-.138.762.762,0,0,0-.743,1.309A10.148,10.148,0,0,1,35.5,15.722c0,.256-.023.509-.044.762a.754.754,0,0,0-.529.057L22.866,22.848,10.235,16.536a.759.759,0,0,0-.512-.051c-.021-.253-.044-.506-.044-.763a10.141,10.141,0,0,1,3.7-7.691A.764.764,0,0,0,12.649,6.7a.8.8,0,0,0-.229.136,11.66,11.66,0,0,0-4.266,8.882,11.652,11.652,0,0,0,4.273,8.885l8.994,7.724-8.968,7.7-.031.025a11.379,11.379,0,0,0,0,17.765.959.959,0,0,0,.1.071.75.75,0,0,0,.4.116.764.764,0,0,0,.485-1.353,10.443,10.443,0,0,1-3.529-5.845l.018,0a.751.751,0,0,0,.354-.088L22.866,44.1l12.05,6.624a.74.74,0,0,0,.39.081,10.432,10.432,0,0,1-3.516,5.843.763.763,0,0,0,.877,1.247,1,1,0,0,0,.092-.067,11.374,11.374,0,0,0,0-17.765M10,18.124l12.534,6.263a.767.767,0,0,0,.694-.006l11.952-6.248a10.556,10.556,0,0,1-3.42,5.316l-9.168,7.876-9.177-7.88A10.546,10.546,0,0,1,10,18.124M35.483,49.291,23.242,42.562a.759.759,0,0,0-.722-.006L9.7,49.292c-.005-.117-.021-.233-.021-.352a10.144,10.144,0,0,1,3.71-7.7l.031-.024,9.171-7.876,9.168,7.876.028.023a10.139,10.139,0,0,1,3.716,7.7c0,.118-.016.233-.02.351",
    transform: "translate(0.304 0.248)",
    fill: "#2c3584",
    stroke: "#2c3584",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroPic2);
export default __webpack_public_path__ + "static/media/hero_pic2.47d583b47216d7494fdc4d79784e697a.svg";
export { ForwardRef as ReactComponent };